var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon-container"},[(_vm.type === _vm.DATA_TYPE.get('video'))?_c('span',{staticClass:"video-icon"}):_c('div',{staticClass:"text-icon"},[_vm._v(_vm._s(_vm.markText))])])}
var staticRenderFns = []

export { render, staticRenderFns }